import { ReactElement, ReactNode } from 'react'
import {
  DASHBOARD_RESKIN_FOOTER_INSET_CLASS,
  DASHBOARD_RESKIN_WORDMARK_SIZE_CLASS,
  DASHBOARD_RESKIN_WORDMARK_SRC
} from './dashboardReskinTiles'

interface FooterProps {
  children?: ReactNode
}

const Footer = ({ children }: FooterProps): ReactElement => {
  return (
    <footer
      className={`flex justify-between w-full items-center ${DASHBOARD_RESKIN_FOOTER_INSET_CLASS}`}
    >
      <div className='flex items-start'>
        <img
          src={DASHBOARD_RESKIN_WORDMARK_SRC}
          className={DASHBOARD_RESKIN_WORDMARK_SIZE_CLASS}
          alt='ZenithShield'
        />
      </div>
      {children}
    </footer>
  )
}

export default Footer
